/* eslint-disable no-console */
import { register } from 'register-service-worker';
import { dispatchAction } from '@/store/storeUtils';
let thisRegistration;

/**
 * Different order of calling the callbacks:
 *
 * Page Refresh:
 * 1. Registered
 * 2. Ready
 *
 * Reload after clear site data:
 * 1. Registered
 * 2. UpdateFound (however no real update)
 * ==> Login displayed
 * 3. Cached (pre-cache manifest files cached)
 * 4. Ready
 * 5. App erhält controllerChange event und führt einen Page reload aus. Kommt wahrsch. aus sw activate
 * Dann folgt wieder registered->ready
 *
 * App Bundle is updated:
 * 1. updateFound
 * 2. updated
 * 3. After User confirms, the waiting step is skipped and the app reloaded
 * 4. Registered -> Ready
 */
export function performServiceWorkerRegistration(VUE_APP_PWA_ENABLED) {
  console.log(`REGISTER SERVICE WORKER with VUE_APP_PWA_ENABLED=${VUE_APP_PWA_ENABLED}, ${typeof VUE_APP_PWA_ENABLED}`);
  if (VUE_APP_PWA_ENABLED === true) {
    console.log(`Registering Service Worker`);
    //register(`/service-worker.js`, {
    register(`${process.env.BASE_URL}service-worker.js`, {
      cached() {
        console.log('cached - Service Worker has completed PRE-CACHE-FETCHING (cached)');
      },
      ready() {
        console.log('ready - Service Worker is READY. App is being served from cache by a service worker');
        localStorage.setItem('deviceId', 'awuioequ23o9890809q32849038490380');
        dispatchAction('lifecycle/setAppStates', { preCacheLoaded: true });
      },

      registered(registration) {
        console.log('registered - Service Worker is REGISTERED');
        thisRegistration = registration;

        dispatchAction('lifecycle/setAppStates', { swRegistered: true });

        setInterval(() => {
          console.log(new Date().toHHMMSS(), 'check for updates');
          registration.update();
        }, 60 * 1000);

        document.addEventListener('clearCaches', (e) => {
          console.log('Received clearCaches Event');

          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
          console.log('Cleared caches');
          window.location.reload();
        });
      },

      updatefound() {
        console.log('updateFound - Service Worker has FOUND UPDATE, updates will be cached');
        dispatchAction('lifecycle/setAppStates', { preCacheLoaded: true });
      },
      updated(registration) {
        console.log('updated - Service Worker has been UPDATED');
        // The service worker has been updated.
        // Dispatch a custom event 'swUpdated' which is caught in app.vue. The app displays an update banner
        // to request the users okay for updating.

        document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
        dispatchAction('lifecycle/setAppStates', { preCacheLoaded: true });
      },
      /**
       * Standard vue pwa hook - however it does not seem to work at the time of writing
       */
      offline() {
        console.log('offline - Service Worker has detected OFFLINE Mode');
        console.log('No internet connection found. App is running in offline mode.');
      },
      error(error) {
        console.error('registerServiceWorker#error(): Error during service worker registration:', error);
      },
    });
  }
}
